import React from "react";
import axios from "axios";
import "react-table/react-table.css";
import Pagination from "react-js-pagination";
import { LinearProgress } from "react-md";
import "../../../node_modules/react-md/dist/react-md.indigo-blue.min.css";
import "bootstrap-datepicker/js/bootstrap-datepicker.js";
import "bootstrap-datepicker/dist/css/bootstrap-datepicker.min.css";
import ViewModal from "./_modal/view";
import Loader from "../../_components/loader";
import { NotificationManager } from "react-notifications";
import "react-notifications/lib/notifications.css";
import { AdminUrls } from "../../network/config";
import "./style.css";
import { removeData } from "../../store/action";
import { connect } from "react-redux";
import yesIcon from "./assets/yes-icon.png";
import noIcon from "./assets/no-icon.png";

const getCpdHost = AdminUrls.ADMIN.GETHOST;
const update_Host_Url = AdminUrls.ADMIN.UPDATEHOST;

class Host extends React.Component {
  constructor() {
    super();
    this.clearSearchFilters = this.clearSearchFilters.bind(this);
    this.getLoadCpd = this.getLoadCpd.bind(this);
    this.modalData = this.modalData.bind(this);
    this.editCourse = this.editCourse.bind(this);
    this.addDataHandler = this.addDataHandler.bind(this);
    this.updateDataHandler = this.updateDataHandler.bind(this);
    this.searchData = this.searchData.bind(this);

    this.state = {
      unauthorized: false,

      loadHost: [],
      dupLoadHost: [],
      username: "",
      sortBy: "",
      editId: "",
      emptyDivMsg: "There is no data to show in the grid.",
      mainLoading: false,
      listViewModalShown: false,
      handleSwitch: false,
      addEditCourseBtn: false,
      search_id: "",
      search_name: "",
      countId: "",
    };
    this.controller = new AbortController();
  }
  componentDidMount() {
    this.getLoadCpd();
  }

  getLoadCpd() {
    this.setState({ mainLoading: true });

    axios
      .get(getCpdHost, {
        method: "GET",
        signal: this.controller.signal,
        withCredentials: true,
        credentials: "include",
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => response.data)
      .then((data) => {
        this.setState({
          loadHost: data,
          dupLoadHost: data,
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  modalData() {
    this.setState({
      listViewModalShown: true,
    });
  }

  addDataHandler() {
    if (!this.state.username) {
      NotificationManager.error("Username should not be empty");
      return false;
    }
    if (!this.state.sortBy) {
      NotificationManager.error("Sortby should not be empty");
      return false;
    }

    this.setState({
      mainLoading: true,
    });
    let obj = {
      Active: this?.state?.handleSwitch,
      Name: this?.state?.username,
      SortOrder: +this?.state?.sortBy,
    };
    let objDup = {
      ID: this?.state?.dupLoadHost?.length + 1,
      Active: this?.state?.handleSwitch,
      Name: this?.state?.username,
      SortOrder: +this?.state?.sortBy,
    };

    axios
      .post(update_Host_Url, obj, {
        withCredentials: true,
        signal: this.controller.signal,
        credentials: "include",
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })
      .then((response) => {
        NotificationManager.success("Host Added Successfully");

        let dupData = [...this.state.dupLoadHost];
        dupData.push(objDup);

        this.setState({
          loadHost: dupData,
          dupLoadHost: dupData,
          listViewModalShown: false,
          mainLoading: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  editCourse(id) {
    let dupData = this?.state?.loadHost;
    let i = dupData?.findIndex((x) => x?.ID === id);

    this.setState({
      editId: id,
      handleSwitch: dupData[i].Active,
      username: dupData[i].Name,
      sortBy: dupData[i].SortOrder,
      addEditCourseBtn: true,
      listViewModalShown: true,
    });
  }

  updateDataHandler() {
    if (!this.state.username) {
      NotificationManager.error("Username should not be empty");
      return false;
    }
    if (!this.state.sortBy) {
      NotificationManager.error("Sortby should not be empty");
      return false;
    }

    let obj = {
      ID: this?.state?.editId,
      Active: this?.state?.handleSwitch,
      Name: this?.state?.username,
      SortOrder: +this?.state?.sortBy,
    };
    axios
      .post(update_Host_Url, obj, {
        withCredentials: true,
        signal: this.controller.signal,
        credentials: "include",
        headers: {
          Authorization:
            `${this.props.user.token_type} ` + this.props.user.access_token,
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
      })

      .then((response) => {
        NotificationManager.success("Host Update Successfully");
        let dupData = [...this.state.loadHost];
        let i = dupData?.findIndex((x) => x?.ID === this.state.editId);

        dupData[i].Active = this.state.handleSwitch;
        dupData[i].Name = this.state.username;
        dupData[i].SortOrder = +this.state.sortBy;

        this.setState({
          editId: "",
          handleSwitch: "",
          username: "",
          sortBy: "",
          addEditCourseBtn: false,
          listViewModalShown: false,
        });
      })
      .catch((error) => {
        if (error?.response?.status && error?.response?.status === 401) {
          this.props.signOut();
        }
      });
  }

  clearSearchFilters() {
    this.setState({
      loadHost: this.state.dupLoadHost,
      search_id: "",
      search_name: "",
    });
  }

  searchData(e) {
    let filtValue = e.target.value;
    let dup = [...this.state.dupLoadHost];

    if (!filtValue) {
      this.setState({
        loadHost: this.state.dupLoadHost,
        search_id: "",
        search_name: "",
      });
    } else {
      let filteredData = dup.filter((item) => {
        return (
          item.ID.toString().includes(filtValue) ||
          item.Name.toString().includes(filtValue)
        );
      });
      if (e.target.id === "name") {
        this.setState({
          loadHost: filteredData,
          search_name: e?.target?.value,
        });
      } else {
        this.setState({
          loadHost: filteredData,
          search_id: e?.target?.value,
        });
      }
    }
  }
  componentWillUnmount() {
    this.controller.abort();
  }

  render() {
    let listViewModalShownClose = () =>
      this.setState({
        listViewModalShown: false,
        addEditCourseBtn: false,
        username: "",
        sortBy: "",
        handleSwitch: false,
      });
    let loadHost;

    if (this.state.loadHost !== null) {
      loadHost = this.state.loadHost?.map((loadHost, index) => {
        return (
          <tr key={index}>
            <td>{loadHost?.ID}</td>
            <td>{loadHost?.Name}</td>
            <td>{loadHost?.SortOrder}</td>
            <td>
              {loadHost?.Active === true ? (
                <img src={yesIcon} alt="yesIcon" />
              ) : (
                <img src={noIcon} alt="noIcon" />
              )}
            </td>
            <td>
              <button
                onClick={() => this.editCourse(loadHost.ID)}
                className="button-custom"
              >
                <i className="fa fa-edit icon-tables"> </i>
              </button>
            </td>
          </tr>
        );
      });
    }

    return (
      <div>
        {this.state.mainLoading && <LinearProgress id="main-loader" />}
        <div>
          <div className="panel panel-default">
            <div className="panel-heading-cpd-3" style={{ padding: "10px" }}>
              <i
                className="fa fa-filter "
                title=""
                data-original-title="Search"
              >
                {" "}
                Search
              </i>
            </div>

            <div className="shadow">
              <div className="layout-gt-sm-row">
                <div style={{ padding: "1rem 1rem" }}>
                  <div className="row">
                    <div className="col-md-6">
                      <div className="form-group admin-host-forms">
                        <label>Name</label>
                        <input
                          type="text"
                          className="form-control"
                          id="name"
                          onChange={(e) => this.searchData(e)}
                          value={this.state.search_name}
                        />
                      </div>
                    </div>
                    <div className="col-md-6">
                      <div className="form-group admin-host-forms">
                        <label>ID</label>
                        <input
                          type="number"
                          className="form-control"
                          id="id"
                          min="0"
                          value={this.state.search_id}
                          onChange={(e) => this.searchData(e)}
                        />
                      </div>
                    </div>
                  </div>

                  <div>
                    <button
                      className="btn btn-primary"
                      style={{ marginRight: "10px" }}
                    >
                      <span className="glyphicon glyphicon-search"> </span>{" "}
                      Search
                    </button>
                    <button
                      className="btn btn-primary"
                      onClick={() => this.clearSearchFilters()}
                    >
                      <span className="glyphicon glyphicon-remove-sign"> </span>{" "}
                      Clear
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="gridTopButtons" style={{ paddingTop: "15px" }}>
            <button
              type="button"
              className="btn btn-primary btn-circle btn-lg "
              onClick={this.modalData}
            >
              <i className="fa fa-plus"> </i>
            </button>
          </div>
        </div>

        <div className="col-table-host">
          {this.state.mainLoading && <Loader />}
          <table className="table table-striped table-hover">
            <thead>
              <tr className="header">
                <th>Host Id</th>
                <th>Name</th>
                <th>Sort Order</th>
                <th>Active</th>
                <th></th>
              </tr>
            </thead>
            <tbody>{loadHost}</tbody>
          </table>
          {loadHost?.length > 0 ? "" : this.state.emptyDivMsg}
          <div>
            <Pagination
              prevPageText="Previous"
              nextPageText="Next"
              firstPageText="First"
              lastPageText="Last"
              activePage={this.state.activePage}
              itemsCountPerPage={this.state.per_page}
              totalItemsCount={this.state.totalCount}
              onChange={this.handlePageChange}
            />
          </div>
        </div>

        <ViewModal
          show={this.state.listViewModalShown}
          data={this.state}
          addeditcoursebtn={this.state.addEditCourseBtn}
          switchcheck={this.state.handleSwitch}
          value_name={this.state.username}
          value_sort={this.state.sortBy}
          name={(e) => this.setState({ username: e })}
          sortBy={(e) => this.setState({ sortBy: e })}
          handleswitch={(e) => this.setState({ handleSwitch: e })}
          onHide={listViewModalShownClose}
          addhandler={this.addDataHandler}
          updatehandler={this.updateDataHandler}
        />
      </div>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    user: state,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    signOut: () => dispatch(removeData()),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Host);
